import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import { screens } from "tailwindcss/defaultTheme";
import { swipeSlideOnFocus } from "../../utils/swiper_util";
import "src/decidim/volunteering/offers/offer_remaining_time";
window.createOffersSlider = (element) => {
  const swiperContainerElement = element.closest(".swiper-container");
  const swiperInstance = new Swiper(element, {
    modules: [Navigation],
    navigation: {
      nextEl: swiperContainerElement.querySelector(".swiper-button-next"),
      prevEl: swiperContainerElement.querySelector(".swiper-button-prev")
    },
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      [parseInt(screens.sm)]: {
        slidesPerView: 2.1,
        spaceBetween: 16
      },
      [parseInt(screens.lg)]: {
        slidesPerView: 3.1,
        spaceBetween: 16
      },
      [parseInt(screens.xl)]: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  });
  swipeSlideOnFocus(element, swiperInstance);
  return swiperInstance;
};
